import { z } from 'zod/v4';
import { PaymentPlanStatus } from '../../economy/payment-plans/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { searchEnvelopeSchema, searchInputSchema } from './envelope.js';
const filtersSchema = z.object({});
const itemSchema = z.object({
    paymentPlanId: z.uuid(),
    status: z.enum(PaymentPlanStatus),
    installmentCount: z.number().int(),
    paidInstallmentCount: z.number().int(),
    totalScheduled: z.string().describe('Decimal amount in the case currency.'),
    totalPaid: z.string().describe('Decimal amount in the case currency.'),
    nextDueDate: z.iso.date().nullable(),
    nextDueAmount: z
        .string()
        .nullable()
        .describe('Decimal amount in the case currency.'),
    createdAt: z.iso.datetime(),
});
const facetsSchema = z.object({
    byStatus: z.record(z.enum(PaymentPlanStatus), z.number().int()),
});
const inputSchema = searchInputSchema(filtersSchema);
const outputSchema = searchEnvelopeSchema(itemSchema, facetsSchema);
export const searchPaymentPlansTool = {
    name: ToolName.SearchPaymentPlans,
    category: ToolCategory.Vouchers,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'List all payment plans on this case (active, cancelled, finished, etc.), most recent first. No filters — cases rarely have many plans. Use get_current_payment_plan for the active plan and get_payment_plan for detail on any specific plan.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=search-payment-plans.js.map